import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import JSZip from 'jszip';
import moment from 'moment';
import { formatTime } from '@/utils/date';
declare const saveAs: any;

@Component({
    name: 'competency-report-csv',
})

export default class CompetencyReportCSV extends Vue  {


    // ---------------------------------------------------------------------
    // Properties

    @Prop()
    private propBind: any;

    private get zipFile() {
        return this.parseCSVFile();
    }

    private parsedData: any = {};

    @Watch('propBind', {deep: true})
    private onWatchPropData() {
        this.parseReportData();
    }


    // ---------------------------------------------------------------------
    // Hooks

    // ---------------------------------------------------------------------
    // Actions

    private onDownload() {
        this.zipFile.generateAsync({type: 'blob'}).then((content) => {
            saveAs(content, 'groups.zip');
        });
    }

    // ---------------------------------------------------------------------
    // Methods

    private parseCSVFile() {
      const zipData = new JSZip();
      const propBind = this.parsedData;
      const groupType = propBind.groupType;
      const usersDrillDownData = propBind.usersDrillDownData;
      const timespentData = propBind.timespentData;
      const performanceData = propBind.performanceData;
      const competencyData = propBind.competencyData;
      const classTimespentData = propBind.classTimespentData;
      const classCompetencyData = propBind.classCompetencyData;

      if (groupType !== 'class') {
          this.getCSVData(zipData, usersDrillDownData, 'users');
          this.getCSVData(zipData, timespentData, 'timespent');
          this.getCSVData(zipData, performanceData, 'performance');
          this.getCSVData(zipData, competencyData, 'competency');
      } else {
        this.getCSVData(zipData, classTimespentData, 'class-timespent');
        this.getCSVData(zipData, classCompetencyData, 'class-competency');
      }
      return zipData;
    }

    private getCSVData(zipData: any, content: any, folderName: string) {
        const propBind = this.propBind;
        let coordinates = content.coordinates || [];
        const drilldown = content.drilldown || [];
        const users = zipData.folder(folderName);
        coordinates = this.convertDateFormat(coordinates);
        const reportDate = moment(`${this.propBind.activeYear}-${this.propBind.activeMonth}`).format('YYYY-MM');
        this.createCSVSheet(this.getHeaders(coordinates), coordinates, users, `datewise-report-${propBind.groupType}-${reportDate}`);
        this.createCSVSheet(this.getHeaders(drilldown), drilldown, users, `report-${propBind.groupType}-${reportDate}`);
    }

    private getHeaders(content: any) {
        if (content && content.length) {
            const firstObj = content[0];
            return Object.keys(firstObj);
        }
        return [];
    }

    private createCSVSheet(headers: string[], content: any, zipFolder: any, fileName: string) {
        let csvData = '';
        csvData += headers.join(',') + '\n';
        csvData += content.map((item: any) => Object.values(item).map(
            (column: any) => JSON.stringify(column)).join(',')).join('\n');
        const coBlob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
        zipFolder!.file(`${fileName}.csv`, coBlob);
    }

    private convertDateFormat(coordinates: any) {
        const activeMonth = this.propBind.activeMonth;
        const activeYear = this.propBind.activeYear;
        coordinates = JSON.parse(JSON.stringify(coordinates));
        return coordinates.map((item: any) => {
            item.date = `${activeYear}-${activeMonth}-${item.label}`;
            delete item.label;
            return item;
        });
    }

    /**
     * @function parseReportData Help to parse the performance and timespent data to readable format
     */
    private parseReportData() {
      const propBind = JSON.parse(JSON.stringify(this.propBind));
      const {timespentData , performanceData, classTimespentData, classCompetencyData} = propBind;
      [timespentData , performanceData, classTimespentData, classCompetencyData].forEach((item) => {
          if (item) {
            const {drilldown, coordinates} = item;
            [drilldown, coordinates].forEach((contents) => {
                if (contents && contents.length) {
                    contents.forEach((content: any) => {
                       Object.keys(content).forEach((contentKey) => {
                            if (contentKey.indexOf('Timespent') !== -1) {
                                content[contentKey] = formatTime(content[contentKey]);
                            } else if (contentKey.indexOf('Performance') !== -1) {
                                content[contentKey] = Math.round(content[contentKey]);
                            }
                       });
                    });
                }
            });
          }
      });
      this.parsedData = propBind;
    }


}

